/**
 * The JS file for the A/B testing functionality in Grist.
 */
import { getCookie, setCookie, deleteOldCookie } from './cookie-manager.js';

function getABTestVariant(testName) {

  let variant = getCookie(`ab_testing_${testName}`); // Check if a variant is already set in cookie

  if (!variant) {
    const variants = [
      'sticky-nav-newsletter-sept-a',
      'sticky-nav-newsletter-sept-b',
    ];

    variant = variants[Math.floor(Math.random() * variants.length)];

    setCookie(`ab_testing_${testName}`, variant, 60); // Store for 60 days

  }
  return variant;
}

// Call this early on page load.
const headerVariant = getABTestVariant('sticky_nav_variants_sept');

// You can make this global or pass it around.
// sticky-nav-newsletter-sept-a = variant with live border outline
// sticky-nav-newsletter-sept-b = variant with only text
window.abTestHeaderVariant = ('sticky-nav-newsletter-sept-a' === headerVariant) ? 'sticky-header-a' : 'sticky-header-b';

const viewportWidth = window.innerWidth;


// Push the variant as a user property to the dataLayer if the cookie exists.
// This will make it available for the GA4 Configuration Tag.
if (headerVariant) {

  window.dataLayer = window.dataLayer || [];

  // Push the variant as a user property to the dataLayer
  window.dataLayer.push({
    'event': 'sticky_menu_variant_view',
    'sticky_menu_variant': headerVariant // Parameter for this specific event.
  });

  // Track clicks on the sticky menu buttons
  document.addEventListener('click', function (e) {

    const anchorTag = e.target.closest('a');

    // Check if the clicked element is a sticky menu button
    if (anchorTag && (anchorTag.classList.contains('sticky-menu-donate-button') || anchorTag.classList.contains('sticky-menu-follow-button'))) {
      if (!e.isTrusted) return;

      const hrefValue = anchorTag.href;
      const type = anchorTag.classList.contains('sticky-menu-donate-button') ? 'donate' : 'newsletter';


      // Push the variant, event, button type as a user property to the dataLayer.
      window.dataLayer.push({
        event: 'sticky_menu_button_click',
        sticky_menu_variant: headerVariant,
        button_type: type,
        link_url: hrefValue || '',
      });
    }
  });
}

// If the viewport width is greater than 400px, we can proceed with the A/B test header.
if ( 400 < viewportWidth ) {
  document.addEventListener('DOMContentLoaded', () => {
    const currentVariant = window.abTestHeaderVariant; // Get the assigned variant

    // Hide all variants first (if not already hidden by default CSS)
    document.querySelectorAll('.appeal-bar-notification').forEach(el => {
      el.style.display = 'none';
    });
    // Show the assigned variant
    const activeHeaderElement = document.getElementById(`appeal-bar-${currentVariant}`);
    if (activeHeaderElement) {
      activeHeaderElement.style.display = 'block'; // Or 'flex', 'grid' etc. based on your CSS
    }
  });
}
